/* eslint-disable */
export default {
  tollFree: '무료',
  rcvPmiMeetingTitle: '{extensionName} 님의 화상 모임',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
